import { c as _c } from "react/compiler-runtime";
import type { PostHostedOnboardingPrefillChallengeResponse, PrefillContext, PrefillPostRequest } from '@onefootprint/request-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { EmailPin } from './email-pin';
import { PasskeyChallenge } from './passkey-challenge';
type ChallengeProps = {
  context: PrefillContext;
  prefillMutation: UseMutationResult<void, unknown, PrefillPostRequest>;
  authToken: string;
  challengeData?: PostHostedOnboardingPrefillChallengeResponse;
};
export const Challenge = t0 => {
  const $ = _c(24);
  const {
    context,
    prefillMutation,
    authToken,
    challengeData
  } = t0;
  const {
    t
  } = useTranslation("idv2");
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-heading-3 text-primary">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== context.scrubbedEmailForChallenge) {
    t3 = context.scrubbedEmailForChallenge && <p className="text-body-2 text-secondary">{context.scrubbedEmailForChallenge.replaceAll("*", "\u2022")}</p>;
    $[4] = context.scrubbedEmailForChallenge;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col text-center">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== challengeData || $[10] !== context.scrubbedEmailForChallenge || $[11] !== prefillMutation || $[12] !== t) {
    t5 = context.scrubbedEmailForChallenge && challengeData ? <EmailPin prefillMutation={prefillMutation} challengeData={challengeData} /> : <p className="text-body-2 text-primary">{t(_temp2)}</p>;
    $[9] = challengeData;
    $[10] = context.scrubbedEmailForChallenge;
    $[11] = prefillMutation;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== authToken || $[15] !== context.supportsPasskeyChallenge || $[16] !== prefillMutation) {
    t6 = context.supportsPasskeyChallenge && <PasskeyChallenge prefillMutation={prefillMutation} authToken={authToken} />;
    $[14] = authToken;
    $[15] = context.supportsPasskeyChallenge;
    $[16] = prefillMutation;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex flex-col gap-5 items-center text-center">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t4 || $[22] !== t7) {
    t8 = <div className="flex flex-col gap-4 px-5 pb-8">{t4}{t7}</div>;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
function _temp($) {
  return $.collectData.prefill.confirmItsYou;
}
function _temp2($_0) {
  return $_0.collectData.prefill.existingAccount;
}